import React, { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { Link, useLocation, useNavigate } from 'react-router-dom';

export default function Cari() {
    const [tabel, setTabel] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const { state } = useLocation();
    const { param } = state || {};
    const [searchVal, setSearchVal] = useState(param || '');

    const fetchData = async () => {
        setLoading(true);
        try {
            const { data } = await axios.get(`cari/${param || ''}`);
            if (data) {
                setTabel(data);
            }
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
        setSearchVal(param || '');
    }, [param]);

    const filteredRows = useMemo(() => {
        const keyword = searchVal.trim().toLowerCase();
        if (!keyword) {
            return tabel;
        }

        return tabel.filter((row) => JSON.stringify(row).toLowerCase().includes(keyword));
    }, [searchVal, tabel]);

    const submitSearch = (event) => {
        event.preventDefault();
        const nextParam = searchVal.trim();
        if (nextParam) {
            navigate('/cari', { state: { param: nextParam } });
        }
    };

    return (
        <main className="min-h-screen bg-slate-50 px-4 py-8 text-brand-navy sm:px-6">
            <div className="mx-auto max-w-6xl">
                <Link to="/" className="inline-flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-extrabold text-brand-navy no-underline transition hover:bg-white">
                    <span aria-hidden="true">&larr;</span>
                    Kembali
                </Link>

                <div className="mt-6 rounded-lg border border-slate-200 bg-white p-5 shadow-soft">
                    <div className="mb-5 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
                        <div>
                            <span className="text-xs font-extrabold uppercase tracking-normal text-brand-green">Pencarian</span>
                            <h1 className="mt-2 font-display text-2xl font-extrabold sm:text-3xl">Hasil Pencarian berdasarkan Title</h1>
                        </div>

                        <form onSubmit={submitSearch} className="flex w-full gap-2 sm:max-w-md">
                            <input
                                value={searchVal}
                                onChange={(event) => setSearchVal(event.target.value)}
                                placeholder="Cari publikasi..."
                                className="h-11 min-w-0 flex-1 rounded-lg border border-slate-200 bg-white px-4 text-sm font-semibold outline-none transition focus:border-brand-green focus:ring-2 focus:ring-brand-green/20"
                            />
                            <button
                                type="submit"
                                className="h-11 rounded-lg bg-brand-navy px-5 text-sm font-extrabold text-white transition hover:bg-brand-green"
                            >
                                Cari
                            </button>
                        </form>
                    </div>

                    <div className="overflow-x-auto">
                        <table className="min-w-full divide-y divide-slate-200 text-left text-sm">
                            <thead className="bg-brand-soft text-xs font-extrabold uppercase tracking-normal text-slate-600">
                                <tr>
                                    <th className="w-16 px-4 py-4">No</th>
                                    <th className="min-w-80 px-4 py-4">Title Publikasi</th>
                                    <th className="min-w-52 px-4 py-4">Penulis/Author</th>
                                    <th className="min-w-44 px-4 py-4">Jenis Publikasi</th>
                                    <th className="min-w-56 px-4 py-4">Email</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-slate-100">
                                {loading ? (
                                    <tr>
                                        <td colSpan="5" className="px-4 py-10 text-center text-sm font-semibold text-slate-500">
                                            Memuat hasil pencarian...
                                        </td>
                                    </tr>
                                ) : null}

                                {!loading && filteredRows.length === 0 ? (
                                    <tr>
                                        <td colSpan="5" className="px-4 py-10 text-center text-sm font-semibold text-slate-500">
                                            Data tidak ditemukan.
                                        </td>
                                    </tr>
                                ) : null}

                                {!loading && filteredRows.map((row, index) => (
                                    <tr key={`${row?.judul || 'hasil'}-${index}`} className="align-top transition hover:bg-slate-50">
                                        <td className="px-4 py-4 font-bold text-slate-500">{index + 1}.</td>
                                        <td className="px-4 py-4">
                                            <a href={row?.url} target="_blank" rel="noreferrer" className="font-extrabold leading-6 text-brand-navy no-underline hover:text-brand-green">
                                                {row?.judul || '-'}
                                            </a>
                                        </td>
                                        <td className="px-4 py-4 text-base font-semibold text-slate-700">{row?.nama || '-'}</td>
                                        <td className="px-4 py-4 text-slate-700">{row?.tipe || '-'}</td>
                                        <td className="px-4 py-4 text-slate-700">{row?.email || '-'}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </main>
    );
}
